import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-download-icon',
  template: `<a class="download" [title]="title"><i class="icon icon-download"></i>{{ label }}</a>`,
  styleUrl: './download-icon.component.scss',
})
export class DownloadIconComponent {
  @Input() title: string;
  @Input() label: string;
}
